import { useIntl } from '@/intl'
import {
  FilterContainer,
  FilterDescription,
  FilterLabel,
} from '@/scopes/checkout/components/services/CarRentalFilteringService/FilterableCars/Filters/Filters'
import * as React from 'react'

export function ChildSeatsFilter() {
  const intl = useIntl()

  return (
    <FilterContainer>
      <FilterLabel>{intl.formatMessage({ id: `checkout_steps_ancillaries_car_rental_filtering_filters_child_seats_label` })}</FilterLabel>
      <FilterDescription>{intl.formatMessage({ id: `checkout_steps_ancillaries_car_rental_filtering_filters_child_seats_type_supporting_text` })}</FilterDescription>
    </FilterContainer>
  )
}
